/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  QraftServiceOperationsToken,
  RequestFnResponse,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationUseMutationOptions,
} from '@openapi-qraft/tanstack-query-react-types';
import type { Mutation, MutationCache, MutationState, UseMutationResult } from '@tanstack/react-query';

import type { paths } from '../schema';

export interface WebhooksService {
  /**
   * @summary Handle Surge Webhook
   * @description Handle message status updates from Surge.
   *
   * Surge sends webhooks for various message events:
   * - message.sent: Message was sent successfully
   * - message.delivered: Message was delivered to recipient
   * - message.failed: Message failed to send
   * - message.received: Inbound message received
   */
  handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost: {
    /**
     * @summary Handle Surge Webhook
     * @description Handle message status updates from Surge.
     *
     * Surge sends webhooks for various message events:
     * - message.sent: Message was sent successfully
     * - message.delivered: Message was delivered to recipient
     * - message.failed: Message failed to send
     * - message.received: Inbound message received
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
        options: ServiceOperationMutationFnOptions<
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError
      >
    >;
    /**
     * @summary Handle Surge Webhook
     * @description Handle message status updates from Surge.
     *
     * Surge sends webhooks for various message events:
     * - message.sent: Message was sent successfully
     * - message.delivered: Message was delivered to recipient
     * - message.failed: Message failed to send
     * - message.received: Inbound message received
     */
    getMutationKey(
      parameters: DeepReadonly<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters> | void
    ): ServiceOperationMutationKey<
      HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
      HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Handle Surge Webhook
     * @description Handle message status updates from Surge.
     *
     * Surge sends webhooks for various message events:
     * - message.sent: Message was sent successfully
     * - message.delivered: Message was delivered to recipient
     * - message.failed: Message failed to send
     * - message.received: Inbound message received
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody, TContext = unknown>(
      parameters: DeepReadonly<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
        TVariables,
        OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
        TContext
      >
    ): UseMutationResult<
      HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
      OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Handle Surge Webhook
     * @description Handle message status updates from Surge.
     *
     * Surge sends webhooks for various message events:
     * - message.sent: Message was sent successfully
     * - message.delivered: Message was delivered to recipient
     * - message.failed: Message failed to send
     * - message.received: Inbound message received
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
        TVariables,
        OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
        TContext
      >
    ): UseMutationResult<
      HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
      OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Handle Surge Webhook
     * @description Handle message status updates from Surge.
     *
     * Surge sends webhooks for various message events:
     * - message.sent: Message was sent successfully
     * - message.delivered: Message was delivered to recipient
     * - message.failed: Message failed to send
     * - message.received: Inbound message received
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostTotal = qraft.webhooksService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostTotal = qraft.webhooksService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
            OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
            OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Handle Surge Webhook
     * @description Handle message status updates from Surge.
     *
     * Surge sends webhooks for various message events:
     * - message.sent: Message was sent successfully
     * - message.delivered: Message was delivered to recipient
     * - message.failed: Message failed to send
     * - message.received: Inbound message received
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostPendingMutationVariables = qraft.webhooksService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostMutationData = qraft.webhooksService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
        OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
        MutationVariables<
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
            OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
            OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
          OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
          MutationVariables<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Handle Surge Webhook
     * @description Handle message status updates from Surge.
     *
     * Surge sends webhooks for various message events:
     * - message.sent: Message was sent successfully
     * - message.delivered: Message was delivered to recipient
     * - message.failed: Message failed to send
     * - message.received: Inbound message received
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
            OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
            OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Handle Surge Webhook
     * @description Handle message status updates from Surge.
     *
     * Surge sends webhooks for various message events:
     * - message.sent: Message was sent successfully
     * - message.delivered: Message was delivered to recipient
     * - message.failed: Message failed to send
     * - message.received: Inbound message received
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.webhooksService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.webhooksService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
              OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
              OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
              TContext
            >
      ):
        | Mutation<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError,
            MutationVariables<
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
              OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
              OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
              TContext
            >
      ): Array<
        Mutation<
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError,
          MutationVariables<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters
          >,
          TContext
        >
      >;
    };
    schema: HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema;
    types: {
      parameters: HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters;
      data: HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData;
      error: HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError;
      body: HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody;
    };
  };
  /**
   * @summary Handle Surge Conversation Webhook
   * @description Handle conversation updates from Surge.
   *
   * This can include:
   * - New conversations created
   * - Conversation status changes
   * - Contact information updates
   */
  handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost: {
    /**
     * @summary Handle Surge Conversation Webhook
     * @description Handle conversation updates from Surge.
     *
     * This can include:
     * - New conversations created
     * - Conversation status changes
     * - Contact information updates
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
        options: ServiceOperationMutationFnOptions<
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError
      >
    >;
    /**
     * @summary Handle Surge Conversation Webhook
     * @description Handle conversation updates from Surge.
     *
     * This can include:
     * - New conversations created
     * - Conversation status changes
     * - Contact information updates
     */
    getMutationKey(
      parameters: DeepReadonly<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters> | void
    ): ServiceOperationMutationKey<
      HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
      HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Handle Surge Conversation Webhook
     * @description Handle conversation updates from Surge.
     *
     * This can include:
     * - New conversations created
     * - Conversation status changes
     * - Contact information updates
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
        TVariables,
        OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
        TContext
      >
    ): UseMutationResult<
      HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
      OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Handle Surge Conversation Webhook
     * @description Handle conversation updates from Surge.
     *
     * This can include:
     * - New conversations created
     * - Conversation status changes
     * - Contact information updates
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
        TVariables,
        OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
        TContext
      >
    ): UseMutationResult<
      HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
      OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Handle Surge Conversation Webhook
     * @description Handle conversation updates from Surge.
     *
     * This can include:
     * - New conversations created
     * - Conversation status changes
     * - Contact information updates
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostTotal = qraft.webhooksService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostTotal = qraft.webhooksService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
            OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
            OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Handle Surge Conversation Webhook
     * @description Handle conversation updates from Surge.
     *
     * This can include:
     * - New conversations created
     * - Conversation status changes
     * - Contact information updates
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostPendingMutationVariables = qraft.webhooksService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostMutationData = qraft.webhooksService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
        OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
        MutationVariables<
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
            OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
            OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
          OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
          MutationVariables<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Handle Surge Conversation Webhook
     * @description Handle conversation updates from Surge.
     *
     * This can include:
     * - New conversations created
     * - Conversation status changes
     * - Contact information updates
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
            OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
            OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Handle Surge Conversation Webhook
     * @description Handle conversation updates from Surge.
     *
     * This can include:
     * - New conversations created
     * - Conversation status changes
     * - Contact information updates
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.webhooksService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.webhooksService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
              OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
              OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
              TContext
            >
      ):
        | Mutation<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError,
            MutationVariables<
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
              OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
              OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
              TContext
            >
      ): Array<
        Mutation<
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError,
          MutationVariables<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters
          >,
          TContext
        >
      >;
    };
    schema: HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema;
    types: {
      parameters: HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters;
      data: HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData;
      error: HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError;
      body: HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody;
    };
  };
}
/**
 * @summary Handle Surge Webhook
 * @description Handle message status updates from Surge.
 *
 * Surge sends webhooks for various message events:
 * - message.sent: Message was sent successfully
 * - message.delivered: Message was delivered to recipient
 * - message.failed: Message failed to send
 * - message.received: Inbound message received
 */
export const handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost = {
  schema: {
    method: 'post',
    url: '/messaging/webhooks/surge/message-status',
    mediaType: ['application/json'],
  },
} as {
  schema: HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema;
  [QraftServiceOperationsToken]: WebhooksService['handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost'];
};
/**
 * @summary Handle Surge Conversation Webhook
 * @description Handle conversation updates from Surge.
 *
 * This can include:
 * - New conversations created
 * - Conversation status changes
 * - Contact information updates
 */
export const handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost = {
  schema: {
    method: 'post',
    url: '/messaging/webhooks/surge/conversation-update',
    mediaType: ['application/json'],
  },
} as {
  schema: HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema;
  [QraftServiceOperationsToken]: WebhooksService['handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost'];
};
export const webhooksService = {
  handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost,
  handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost,
} as const;
type HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema = {
  method: 'post';
  url: '/messaging/webhooks/surge/message-status';
  mediaType: ['application/json'];
};
type HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData =
  paths['/messaging/webhooks/surge/message-status']['post']['responses']['200']['content']['application/json'];
type HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError =
  paths['/messaging/webhooks/surge/message-status']['post']['responses']['422']['content']['application/json'];
type HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody =
  paths['/messaging/webhooks/surge/message-status']['post']['requestBody']['content']['application/json'];
type HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema = {
  method: 'post';
  url: '/messaging/webhooks/surge/conversation-update';
  mediaType: ['application/json'];
};
type HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData =
  paths['/messaging/webhooks/surge/conversation-update']['post']['responses']['200']['content']['application/json'];
type HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError =
  paths['/messaging/webhooks/surge/conversation-update']['post']['responses']['422']['content']['application/json'];
type HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody =
  paths['/messaging/webhooks/surge/conversation-update']['post']['requestBody']['content']['application/json'];
